import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { OpenDialogAddEditDiscountComponent } from 'app/components/dialog/open-dialog-add-edit-discount/open-dialog-add-edit-discount.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-admin-discount',
  templateUrl: './admin-discount.component.html',
  styleUrls: ['./admin-discount.component.scss']
})
export class AdminDiscountComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput: string;
  userConnected: InfosUser;
  title: string;
  clubCode: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private authService: AuthService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue || null;
    this.dataService.valueFilterDiscount$.next(filterValue);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  addOrEditDiscount(action: string, discount?: any): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditDiscountComponent, {
      data: { action, discount },
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.dataService.clubActiveDiscount$.next(res.data);
        this.dataService.updatePromoCode$.next(true);
      }
    });
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    const title = {
      admin: `Liste des réductions du club : ${this.clubCode}`,
      club: `Liste des réductions de mon club`
    };

    this.title = title[this.userConnected.role];
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }
}
